"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTVCommercialStencil = exports.tvCommercialStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.tvCommercialStencilDefinition = {
    view: {
        label: 'TV Commercial',
        category: 'show',
        group: 'Moving images',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: ['title', 'video-essence'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'label',
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'uri-title',
                            'featured-media',
                            'social-media-image',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'standalone',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: ['content-categories'],
            },
        ],
        previewConfiguration: { hasFeatureCardPreview: true },
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.contentClassificationTermsPropertyDefinition.name]: properties_1.contentClassificationTermsPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.labelPropertyDefinition.name]: {
            ...properties_1.labelPropertyDefinition,
            view: {
                label: 'Internal Title',
                readonly: true,
            },
            constraints: [],
        },
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialMediaImagePropertyDefinition.name]: properties_1.socialMediaImagePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
        [properties_1.videoEssencePropertyDefinition.name]: {
            ...properties_1.videoEssencePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'providers',
                    argument: ['Cartoon Video'],
                },
            ],
        },
    },
    localizations: [],
    roles: [],
    spaces: ['cartoons'],
    name: 'tv-commercial',
};
const isTVCommercialStencil = (stencil) => {
    return stencil.name === exports.tvCommercialStencilDefinition.name;
};
exports.isTVCommercialStencil = isTVCommercialStencil;
//# sourceMappingURL=data:application/json;base64,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